import './nuevoStroLight.css';
import { useCallback, useMemo, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import MensajesCronologiaLight from './MensajesCronologiaLight';
import MensajesSistemaCronologiaLight from './MensajesSistemaCronologiaLight';
import MensajesChatCronologiaLight from './MensajesChatCronologiaLight';
export default function CronologiaLight({ denuncia, cookies }) {
  const [mensaje, setMensaje] = useState({ obs: null, motivo: null });

  const motivoMensajeInput = [
    { label: 'IP', value: 'IP' },
    { label: 'INV', value: 'INV' },
    { label: 'INF', value: 'INF' },
    { label: 'DEM', value: 'DEM' },
    { label: 'AUD', value: '' },
    { label: 'DOC', value: 'DOC' },
    { label: 'ARCH', value: 'ARCH' },
    { label: 'ARCH ACP', value: 'ARCH ACP' },
    { label: 'ARCH FCP', value: 'ARCH FCP' },
    { label: 'TDM', value: 'TDM' },
    { label: 'TAT', value: 'TAT' },
    { label: 'TR', value: 'TR' },
    { label: 'OTROS', value: 'OTROS' },
  ];
  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: '#FFFFFF',
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused ? '#42C3BA' : isSelected ? '#42C3BA' : undefined,
      border: isFocused ? '#42C3BA 1px solid' : isSelected ? '#42C3BA 1px solid' : undefined,
      zIndex: 1,
    }),
    menu: base => ({
      ...base,
      zIndex: 100,
    }),
    control: styles => ({
      ...styles,
      background: '#FFFFFF',
      color: 'white',
      borderColor: '#232A61',
    }),
    singleValue: styles => ({
      ...styles,
      color: 'white',
    }),
  };
  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  const formattedDate = day + '/' + month + '/' + year;
  function getCurrentTime() {
    const now = new Date();
    let hour = now.getHours();
    let minute = now.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return hour + ':' + minute;
  }
  const currentTime = getCurrentTime();
  const comentarioUpdate = useCallback(
    async e => {
      e.preventDefault();
      await axios
        .post(`https://back.agsseguros.online/api/cronologia`, {
          id: denuncia.id,
          desc: '',
          obs: mensaje.obs,
          jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
          motivo: mensaje.motivo,
          autor: cookies.user.usuario,
          fecha: formattedDate,
          hora: currentTime,
        })
        .then(response => {
          if (response) {
            window.location.reload();
          }
        });
    },
    [mensaje, denuncia, cookies, currentTime, formattedDate]
  );
  const [filtro, setFiltro] = useState(0);
  const [autoresSeleccionados, setAutoresSeleccionados] = useState([]);
  // Opciones únicas para el Select
  const autoresUnicos = useMemo(() => {
    const autores = denuncia?.cronologia?.map(c => c.autor) || [];
    return [...new Set(autores)].map(autor => ({
      value: autor,
      label: autor,
    }));
  }, [denuncia]);
  // Filtro de mensajes
  let mensajesFiltrados = (denuncia?.cronologia ?? []).filter(m => {
    if (filtro === 0 && (!m.obs || m.obs === '')) return false;
    if (filtro === 1 && (!m.desc || m.desc === '')) return false;
    if (autoresSeleccionados.length > 0 && !autoresSeleccionados.includes(m.autor)) return false;
    return true;
  });
  if (cookies.user.id === 100) {
    const contractualesUsernames = ['Facundo', 'DiegoS', 'danielaD', 'StellaM', 'LucianaF', 'CandelaS', 'MagaliG', 'VivianaD', 'FedericoL', 'MariaE', 'PaulaC'];
    mensajesFiltrados = mensajesFiltrados.filter(mensaje => !contractualesUsernames.includes(mensaje.autor));
  }
  // Renderizado según tipo de mensaje
  let contenido;
  if (filtro === 0) {
    contenido = mensajesFiltrados.map(m => <MensajesChatCronologiaLight key={m.id} mensaje={m} user={cookies.user.id} />);
  } else if (filtro === 1) {
    contenido = mensajesFiltrados.map(m => <MensajesSistemaCronologiaLight key={m.id} mensaje={m} user={cookies.user.id} />);
  } else {
    contenido = mensajesFiltrados.map(m => <MensajesCronologiaLight key={m.id} mensaje={m} user={cookies.user.id} />);
  }
  return (
    <div className='pe-4 ps-4'>
      <div className='chatContainer'>
        <div className='d-flex gap-4 pb-3'>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className='w-100'>
            <div className='d-flex gap-3'>
              <button className={filtro === 0 ? 'botonCronologiaEnUso' : 'botonCronologiaSinUso'} onClick={() => setFiltro(0)}>
                CHAT
              </button>
              <button className={filtro === 1 ? 'botonCronologiaEnUso' : 'botonCronologiaSinUso'} onClick={() => setFiltro(1)}>
                SISTEMA
              </button>
              <button className={filtro === 2 ? 'botonCronologiaEnUso' : 'botonCronologiaSinUso'} onClick={() => setFiltro(2)}>
                CRONOLOGÍA
              </button>
            </div>
            <div>
              <Select
                isMulti
                options={autoresUnicos}
                onChange={selected => setAutoresSeleccionados(selected.map(o => o.value))}
                value={autoresUnicos.filter(o => autoresSeleccionados.includes(o.value))}
                placeholder='Filtrar por autor'
                classNamePrefix='select'
              />
            </div>
          </div>
        </div>
        <div className='mensajesContainer my-scrollbar'>{<div>{contenido}</div>}</div>
        <div className='inputContainer'>
          <textarea
            disabled={cookies?.user?.titulo === 'lector'}
            className='burbujaModuloActualizacionStro1Light burbujaModuloActualizacionStro1Dark3 ps-3 pt-1'
            placeholder='Escriba su mensaje aqui'
            value={mensaje.obs}
            onChange={e =>
              setMensaje(prevState => ({
                ...prevState,
                obs: e.target.value,
              }))
            }
          />
          <div className='sendContainer'>
            <div className='sendMessageBtnContainer center'>
              <button
                className='btnNO text-white'
                onClick={e => comentarioUpdate(e)}
                disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : mensaje.motivo === null}>
                <i className='bi bi-send'></i>
              </button>
            </div>
            <div className='sendMessageUserContainer mt-2'>
              <Select
                disabled={cookies?.user?.titulo === 'lector'}
                styles={colourStyles}
                options={motivoMensajeInput}
                value={mensaje.motivo}
                className='w-100'
                placeholder={mensaje.motivo}
                onChange={newValue =>
                  setMensaje(prevState => ({
                    ...prevState,
                    motivo: newValue.value,
                  }))
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
